import { render, staticRenderFns } from "./patent_index.vue?vue&type=template&id=e8ce6960&"
import script from "./patent_index.vue?vue&type=script&lang=js&"
export * from "./patent_index.vue?vue&type=script&lang=js&"
import style0 from "./patent_index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports